/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartnerParentProjection } from './PartnerParentProjection';
import {
    PartnerParentProjectionFromJSON,
    PartnerParentProjectionFromJSONTyped,
    PartnerParentProjectionToJSON,
    PartnerParentProjectionToJSONTyped,
} from './PartnerParentProjection';

/**
 * 
 * @export
 * @interface PartnerProjection
 */
export interface PartnerProjection {
    /**
     * 
     * @type {number}
     * @memberof PartnerProjection
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerProjection
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerProjection
     */
    email?: string;
    /**
     * 
     * @type {PartnerParentProjection}
     * @memberof PartnerProjection
     */
    parentId?: PartnerParentProjection | null;
}

/**
 * Check if a given object implements the PartnerProjection interface.
 */
export function instanceOfPartnerProjection(value: object): value is PartnerProjection {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function PartnerProjectionFromJSON(json: any): PartnerProjection {
    return PartnerProjectionFromJSONTyped(json, false);
}

export function PartnerProjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerProjection {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'parentId': json['parent_id'] == null ? undefined : PartnerParentProjectionFromJSON(json['parent_id']),
    };
}

export function PartnerProjectionToJSON(json: any): PartnerProjection {
    return PartnerProjectionToJSONTyped(json, false);
}

export function PartnerProjectionToJSONTyped(value?: PartnerProjection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'parent_id': PartnerParentProjectionToJSON(value['parentId']),
    };
}

